<template>
    <div>
        <carousel v-if="clients" class="position-relative" :rewind="true" :dots="true" :margin="24" :responsive="{0:{items:1,nav:false},600:{items:2,nav:false},920:{items:2,nav:false,mouseDrag:false}}">
            <dashboard-client-stats v-for="client in clients" v-bind:client="client" v-bind:key="client.id" v-bind:month="month" v-bind:year="year"></dashboard-client-stats>
            <template slot="prev"><span class="prev position-absolute h-100 d-none d-lg-flex align-items-center" style="top:0;bottom: 0;left:-60px;cursor: pointer">
            <svg id="Layer_1" width="14px" class="text-primary fill-current"  data-name="PrevIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.36 30"><path d="M6.82,15a1.33,1.33,0,0,0,.4,1L20.85,29.6a1.36,1.36,0,0,0,1,.4,1.32,1.32,0,0,0,1-.4,1.37,1.37,0,0,0,0-1.93L10.11,15,22.78,2.33A1.36,1.36,0,0,0,20.85.4L7.22,14A1.33,1.33,0,0,0,6.82,15Z" transform="translate(-6.82 0)"/></svg>
            </span></template>
            <template slot="next"><span class="next position-absolute h-100 d-none d-lg-flex align-items-center" style="top:0;bottom: 0;right:-60px;cursor: pointer">
            <svg id="Layer_1" width="14px" class="text-primary fill-current" data-name="NextIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.36 30"><path d="M22.78,14,9.15.4A1.36,1.36,0,0,0,7.22,2.33L19.89,15,7.22,27.67a1.37,1.37,0,0,0,0,1.93,1.32,1.32,0,0,0,1,.4,1.36,1.36,0,0,0,1-.4L22.78,16a1.35,1.35,0,0,0,0-1.92Z" transform="translate(-6.82 0)"/></svg>
        </span></template>
        </carousel>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

    export default {
        name: "Dashboard",
        components: { carousel },
        data() {
            return {
                clients: null,
                month:null,
                year:null
            }
        },
        mounted: function() {
            let d = new Date();
            this.year = d.getFullYear();
            this.month = ((d.getMonth() + 1) < 10 ? '0' : '') + (d.getMonth() + 1);
            axios.post('/admin/clientlist').then(response => {
                this.clients = response.data;
            });
        }
    }
</script>

<style scoped>
    button.owl-dot:focus {
        outline: 0 !important;
    }
</style>
